module.exports = __webpack_public_path__ + "9c32a4bc218a3a146cddd73a9fea3265.svg";